// import axios from 'axios'
const axios = require("axios");

import { npAES, npRSA } from "./npCipher";
import npConfig from "./nos.config";
// const npConfig = require("@/../nos.config");

export const npMessage = {
  m30:
    "서버에서 키값을 얻어올 수 없습니다. 서버의 상태 또는 접속경로를 확인하여 주십시오.",
  m45:
    "문자형키패드는 텍스트입력양식에서 사용할 수 없습니다. 텍스트입력양식에서는 숫자/한글형키패드만 지원합니다.",
  m46:
    "한글키패드는 암호입력양식에서 사용할 수 없습니다. 암호입력양식에서는 숫자/문자형키패드만 지원합니다.",
  m77: "입력양식(%p1%)에 [(%p2%)] 속성으로 활성화양식명을 지정하여 주십시오.",
  m78: "입력양식(%p1%)의 마우스입력기가 정상적으로 초기화되었습니다.",
  m79: "마우스입력기(%p1%)가 활성화되었습니다.",
  m80: "마우스입력기(%p1%)가 비활성화되었습니다.",
};

var nua = navigator.userAgent;
export const npDefine = new (function() {
  var nav = navigator.appName;
  var plt = navigator.platform.toLowerCase();
  function npos(txt) {
    return nua.indexOf(txt);
  }
  function nin(txt) {
    return nua.indexOf(txt) >= 0;
  }
  function lnin(txt) {
    return nua.toLowerCase().indexOf(txt) >= 0;
  }
  this.ie =
    (nav == "Microsoft Internet Explorer" ||
      (nav == "Netscape" && (nin("MSIE") || nin("Trident")))) &&
    !nin("QQBrowser");
  this.ie64 = this.ie && nin("Win64; x64");
  this.edge = npos("Mozilla") === 0 && (nin("Edge/") || nin("Edg/"));
  this.ff =
    nin("Firefox") &&
    npos("Mozilla") === 0 &&
    nav == "Netscape" &&
    !nin("Navigator");
  this.ns = nin("Gecko") && nin("Navigator");
  this.b360 = nin("360Browser") && nin("Chrome") && nin("Safari");
  this.qq = nin("QQBrowser") && nin("Trident");
  this.sf = nin("Safari") && !nin("Chrome");
  this.op = nin("Opera") || nin("OPR/");
  this.cr =
    nin("Chrome") &&
    nin("Safari") &&
    !nin("OPR/") &&
    !nin("360Browser") &&
    !nin("Edg/") &&
    !nin("Edge/");
  this.win = plt.indexOf("win") != -1 && !nin("Windows Phone");
  //	this.win98 = nin("Windows 98") || nin("Win98");
  //	this.winme = nin("Windows ME");
  //	this.winnt40 = nin("Windows NT 4.0");
  //	this.win64 = (plt.indexOf('win64') != -1) && !lnin('windows phone');
  this.win9x =
    nin("Windows 98") ||
    nin("Win98") ||
    nin("Windows ME") ||
    nin("Windows NT 4.0") ||
    nin("Windows NT 5.0") ||
    nin("Windows 2000");
  this.winxp = nin("Windows NT 5.1");
  this.mac = nin("Mac");
  this.lnx64 = nin("Linux") && nin("x86_64");
  this.lnx32 = nin("Linux") && (nin("i386") || nin("i686"));
  this.lnx = nin("Linux");
  this.and = nin("Android");
  this.ios = nin("iPhone") || nin("iPod") || nin("iPad");
  this.iph = nin("iPhone");
  this.ipo = nin("iPod");
  this.ipa = nin("iPad");
  this.fdr = lnin("fedora");
  this.ubt = lnin("ubuntu");
  this.winphone = lnin("windows phone");
  this.winmob = plt == "windows mobile";

  this.osVersion = null;
  this.browserVersion = null;
  this.virtualMachine = false;

  this.isMobileDevice = function() {
    if (
      this.winmob ||
      this.winphone ||
      this.ipa ||
      this.ipo ||
      this.iph ||
      this.and
    )
      return true;
    return false;
  };
})();

export const npCommon = class npCommon {
  static isNull = function(data) {
    if (typeof data == "undefined" || data == null) {
      return true;
    }
    return false;
  };

  static isBlank = function(data) {
    if (typeof data == "undefined" || data == null || data == "") {
      return true;
    }
    return false;
  };

  static n2b = function(data, def) {
    if (this.isNull(def)) def = "";
    if (this.isNull(data)) return def;
    return data;
  };

  static trim = function(str) {
    if (str == null) return str;
    try {
      return str.replace(/(^\s*)|(\s*$)/gi, "");
    } catch (e) {
      try {
        return str.replace(/^\s+|\s+$/g, "");
      } catch (e) {
        //
      }
    }
    return str;
  };

  static hexEncode = function(byteArray) {
    var result = "";
    if (!byteArray) {
      return;
    }
    for (var i = 0; i < byteArray.length; i++) {
      result += (byteArray[i] < 16 ? "0" : "") + byteArray[i].toString(16);
    }
    return result;
  };

  static hexDecode = function(hex, charset) {
    if (npCommon.isBlank(hex)) {
      return "";
    }

    var r = "";
    if (hex.indexOf("0x") == 0 || hex.indexOf("0X") == 0) {
      hex = hex.substr(2);
    }
    if (hex.length % 2) {
      hex += "0";
    }
    var arr = [];
    for (var i = 0; i < hex.length; i += 2) {
      arr.push(parseInt(hex.slice(i, i + 2), 16));
    }
    if (charset == "UTF8") {
      return toString(arr);
    } else {
      for (i = 0; i < arr.length; i++) {
        r += String.fromCharCode(arr[i]);
      }
    }
    return r;
  };

  static getRandomBytes = function(howMany) {
    var i;
    var bytes = new Array();
    for (i = 0; i < howMany; i++) {
      bytes[i] = Math.round(Math.random() * 255);
    }
    return bytes;
  };

  static makeUuid() {
    var dummy = Math.floor(Math.random() * 99) + 1;
    // dummy 값이 두자리가 아닐 경우 패딩 값이 맨 앞자리에 생성됨
    if (dummy < 10) dummy = dummy + 10;
    let uuid = new Date().getTime().toString() + dummy;
    for (let len = uuid.length; len < 15; len++) {
      uuid = "0" + uuid;
    }
    return uuid;
  }

  static eraseSpecialChars(tmp) {
    var regExp = /[{}[]\/?.,;:|\)*~`!^-+<>@#$%&\\=\('"]/gi;
    if (regExp.test(tmp)) {
      var t = tmp.replace(regExp, "");
      tmp = t;
    }
    return tmp;
  }

  static comma(str) {
    str = String(str);
    return str.replace(/(\d)(?=(?:\d{3})+(?!\d))/g, "$1,");
  }

  static uncomma(str) {
    str = String(str);
    return str.replace(/[^\d]+/g, "");
  }

  static formatPlaintext(plaintext) {
    var bpb = 128 / 8; // bytes per block
    var i;

    // if primitive string or String instance
    if (typeof plaintext == "string" || plaintext.indexOf) {
      plaintext = plaintext.split("");
      // Unicode issues here (ignoring high byte)
      for (i = 0; i < plaintext.length; i++) {
        plaintext[i] = plaintext[i].charCodeAt(0) & 0xff;
      }
    }

    // zero padding
    for (i = bpb - (plaintext.length % bpb); i > 0 && i < bpb; i--) {
      plaintext[plaintext.length] = 0;
    }
    return plaintext;
  }

  static encrypt = function(plaintext, key, mode) {
    var blockSizeInBits = 128;
    var keySizeInBits = 256;

    var bpb = blockSizeInBits / 8; // bytes per block
    var i, aBlock;
    var ct; // ciphertext

    if (!plaintext || !key) return;
    if (key.length * 8 != keySizeInBits) {
      return;
    }
    if (mode == "CBC") ct = npCommon.getRandomBytes(bpb);
    // get IV
    else {
      mode = "ECB";
      ct = new Array();
    }

    // convert plaintext to byte array and pad with zeros if necessary.
    plaintext = npCommon.formatPlaintext(plaintext);
    //npConsole.log("plaintext : " + npCommon.hexEncode(plaintext));

    var expandedKey = new npAES.keyExpansion(key);
    for (var block = 0; block < plaintext.length / bpb; block++) {
      aBlock = plaintext.slice(block * bpb, (block + 1) * bpb);
      if (mode == "CBC") {
        for (i = 0; i < bpb; i++) {
          aBlock[i] ^= ct[block * bpb + i];
        }
      }
      ct = ct.concat(npAES.AESencrypt(aBlock, expandedKey));
    }

    return npCommon.hexEncode(ct);
  };

  static decrypt = function(ciphertext, key, mode, charset) {
    var blockSizeInBits = 128;
    var keySizeInBits = 256;

    var bpb = blockSizeInBits / 8; // bytes per block
    var pt = new Array(); // plaintext array
    var aBlock; // a decrypted block
    var block; // current block number
    if (!ciphertext || !key) return;
    if (typeof ciphertext == "string") {
      ciphertext = ciphertext.split("");
      for (i = 0; i < ciphertext.length; i++) {
        ciphertext[i] = ciphertext[i].charCodeAt(0) & 0xff;
      }
    }

    if (key.length * 8 != keySizeInBits) {
      return;
    }
    if (!mode) {
      mode = "ECB"; // assume ECB if mode omitted
    }
    var expandedKey = new npAES.prepareDecryption(key);
    for (block = ciphertext.length / bpb - 1; block > 0; block--) {
      aBlock = npAES.AESdecrypt(
        ciphertext.slice(block * bpb, (block + 1) * bpb),
        expandedKey
      );
      if (mode == "CBC") {
        for (var i = 0; i < bpb; i++) {
          pt[(block - 1) * bpb + i] =
            aBlock[i] ^ ciphertext[(block - 1) * bpb + i];
        }
      } else {
        pt = aBlock.concat(pt);
      }
    }
    // do last block if ECB (skips the IV in CBC)
    if (mode == "ECB") {
      pt = npAES.AESdecrypt(ciphertext.slice(0, bpb), expandedKey).concat(pt);
    }

    // cleanup zero padding
    var tval = pt[pt.length - 1];
    while (typeof tval == "undefined" || tval == null || tval == 0) {
      pt.pop();
      tval = pt[pt.length - 1];
    }

    //return String.fromCharCode.apply(null, new Uint8Array(npCommon.hexDecode(npCommon.hexEncode(pt))));
    return npCommon.hexDecode(npCommon.hexEncode(pt), charset);
  };

  static parsePublicKey = function(result) {
    var ret = {};
    try {
      ret.seedkey = npCommon.hexEncode(npCommon.getRandomBytes(32));
      var ppm = null;
      result = npCommon.trim(result);
      if (!npCommon.isBlank(result) && result.length > 64) {
        var key = result.substring(0, 64);
        var data = result.substring(64);
        ppm = npCommon.decrypt(
          npCommon.hexDecode(data),
          npCommon.hexDecode(key),
          "ECB"
        );
      }

      if (npCommon.isBlank(ppm)) {
        alert(npMessage.m30);
        ret.rsa = false;
        return ret;
      }

      var rsa = npRSA.parse(ppm);
      var enc = rsa.encrypt(ret.seedkey);

      ret.rsakey = enc;
      ret.rsa = true;
    } catch (e) {
      ret.rsa = false;
      ret.message = e.message;
    }
    return ret;
  };

  static get(params) {
    return this.ajax("get", npConfig.APPLICATION_URL, params);
  }

  static post(params) {
    return this.ajax("post", npConfig.APPLICATION_URL, params);
  }

  static ajax(method, url, params) {
    return new Promise(function(resolve, reject) {
      // this.vue.$http.defaults.headers.common['Origin'] = "http://192.168.1.85:9999";
      // this.vue.$http.defaults.headers.common['Content-Type'] = "text/plain";
      // delete this.vue.$http.defaults.headers.common['Authorization'];
      // delete this.vue.$http.defaults.headers.common['AuthorizationKey'];
      // axios({

      let data = params;
      if (method === "post") {
        // let formData = new FormData();
        // for(const _key in params) {
        //	 const _value = params[_key];
        //	 formData.set(_key, _value);
        // }
        // data = formData;
        // console.log("formData", formData);

        const querystring = require("querystring");
        data = querystring.stringify(params);
      }
      // this.vue.$http({
      axios({
        method: method,
        url: url,
        params: method !== "post" ? data : null,
        data: method === "post" ? data : null,
        headers: {
          // 'Authorization': null,
          // 'AuthorizationKey': null,
          // 'Access-Control-Request-Headers': null
        },
        withCredentials: true,
      })
        // this.vue.$http.post(url, formData)
        // this.vue.$http.post(url, params)
        .then(
          function(response) {
            // console.log(response);
            if (response.status === 200 && response.data) {
              // console.log(response.data);

              // const data = response.data;
              // const { code, message } = data;
              // if(code === "1000") {
              //	 _this.saveToken(data, _callback);
              // } else if(code === "2001" || code === "2002") {
              //	 _callback(true, code, "", data);
              // } else {
              //	 _callback(false, code, message);
              // }
              resolve(response.data);
            }
          },
          function(err) {
            // console.log('err', err)
            // _callback(false, "", err);
            reject(err);
          }
        );
    });
  }

  static Hangul = {
    initial: [
      12593,
      12594,
      12596,
      12599,
      12600,
      12601,
      12609,
      12610,
      12611,
      12613,
      12614,
      12615,
      12616,
      12617,
      12618,
      12619,
      12620,
      12621,
      12622,
    ],
    finale: [
      0,
      12593,
      12594,
      12595,
      12596,
      12597,
      12598,
      12599,
      12601,
      12602,
      12603,
      12604,
      12605,
      12606,
      12607,
      12608,
      12609,
      12610,
      12612,
      12613,
      12614,
      12615,
      12616,
      12618,
      12619,
      12620,
      12621,
      12622,
    ],
    dMedial: [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      800,
      801,
      820,
      0,
      0,
      1304,
      1305,
      1320,
      0,
      0,
      1820,
    ],
    dFinale: [
      0,
      0,
      0,
      119,
      0,
      422,
      427,
      0,
      0,
      801,
      816,
      817,
      819,
      825,
      826,
      827,
      0,
      0,
      1719,
      0,
      1919,
    ],
    SBase: 44032,
    VCount: 21,
    LCount: 19,
    TCount: 28,
    NCount: 588,
    VBase: 12623,
    SCount: 11172,
    composeHangul: function(word) {
      //한글 조합
      var wordLength = word.length;
      var firstKeyCode = word.charCodeAt(0);
      var returnValue = word; //1자일 경우
      var combineKeyCode = 0;
      for (var i = 1; i < wordLength; i++) {
        var prevKeyCode = word.charCodeAt(i - 1);
        var curKeyCode = word.charCodeAt(i);
        var prevWord = String.fromCharCode(prevKeyCode);
        var idxLastKey = "";
        var subCurKey = "";
        var subPrevKey = "";
        var idxFirstKey = this.findCode(this.initial, prevKeyCode);
        if (idxFirstKey != -1) {
          //이전 단어가 초성일 때
          subCurKey = curKeyCode - this.VBase;
          if (0 <= subCurKey && subCurKey < this.VCount) {
            //현재 단어가 중성일 때
            combineKeyCode =
              this.SBase +
              (idxFirstKey * this.VCount + subCurKey) * this.TCount;
            returnValue =
              prevWord.slice(0, prevWord.length - 1) +
              String.fromCharCode(combineKeyCode);
            continue;
          }
        }
        subPrevKey = prevKeyCode - this.SBase;
        if (
          0 <= subPrevKey &&
          subPrevKey < 11145 &&
          subPrevKey % this.TCount == 0
        ) {
          //이전 단어가 '히' 전이면  11145 = D789 = '힉';
          idxLastKey = this.findCode(this.finale, curKeyCode);
          if (idxLastKey != -1) {
            combineKeyCode = prevKeyCode + idxLastKey;
            returnValue =
              prevWord.slice(0, prevWord.length - 1) +
              String.fromCharCode(combineKeyCode);
            continue;
          }
          subCurKey = (subPrevKey % this.NCount) / this.TCount;
          var tmp = this.findCode(
            this.dMedial,
            subCurKey * 100 + (curKeyCode - this.VBase)
          );
          if (tmp > 0) {
            combineKeyCode = prevKeyCode + (tmp - subCurKey) * this.TCount;
            returnValue =
              prevWord.slice(0, prevWord.length - 1) +
              String.fromCharCode(combineKeyCode);
          }
        }
        if (
          0 <= subPrevKey &&
          subPrevKey < 11172 &&
          subPrevKey % this.TCount != 0
        ) {
          //이전 단어가 한글의 끝 이면 11172 = D7A4 = ' 힤'
          idxLastKey = subPrevKey % this.TCount;
          subCurKey = curKeyCode - this.VBase;
          if (0 <= subCurKey && subCurKey < this.VCount) {
            //현재 단어가 중성일 때
            curKeyCode = this.findCode(this.initial, this.finale[idxLastKey]);
            if (0 <= curKeyCode && curKeyCode < this.LCount) {
              let tmpPrevWord =
                prevWord.slice(0, prevWord.length - 1) +
                String.fromCharCode(firstKeyCode - idxLastKey);
              let tmpFirstKeyCode =
                this.SBase +
                (curKeyCode * this.VCount + subCurKey) * this.TCount;
              returnValue = tmpPrevWord + String.fromCharCode(tmpFirstKeyCode);
              continue;
            }
            if (
              idxLastKey < this.dFinale.length &&
              this.dFinale[idxLastKey] != 0
            ) {
              let tmpPrevWord =
                prevWord.slice(0, prevWord.length - 1) +
                String.fromCharCode(
                  firstKeyCode -
                    idxLastKey +
                    Math.floor(this.dFinale[idxLastKey] / 100)
                ); //받침빼기
              let tmp = this.findCode(
                this.initial,
                this.finale[this.dFinale[idxLastKey] % 100]
              );
              let tmpFirstKeyCode =
                this.SBase + (tmp * this.VCount + subCurKey) * this.TCount;
              returnValue = tmpPrevWord + String.fromCharCode(tmpFirstKeyCode);
            }
          }
          var tmpIdx = this.findCode(this.finale, curKeyCode);
          var c = this.findCode(this.dFinale, idxLastKey * 100 + tmpIdx);
          if (c > 0) {
            combineKeyCode = prevKeyCode + c - idxLastKey;
            returnValue =
              prevWord.slice(0, prevWord.length - 1) +
              String.fromCharCode(combineKeyCode);
            continue;
          }
        }
      } //for end
      return returnValue;
    }, //end combineHangul
    findCode: function(codeList, key) {
      for (var i = 0; i < codeList.length; i++) {
        if (codeList[i] == key) {
          return i;
        }
      }
      return -1;
    }, // end findCode
    backSpace: function(word) {
      var wordLength = word.length;
      var returnValue = "";
      var idxFirstKey, idxMiddleKey, idxLastKey;
      for (var i = 0; i < wordLength; i++) {
        var curKeyCode = word.charCodeAt(i);
        var idxCurKey = curKeyCode - this.SBase;
        if (idxCurKey < 0 || idxCurKey >= this.SCount) {
          returnValue = String.fromCharCode(curKeyCode);
          continue;
        }
        idxFirstKey = this.initial[Math.floor(idxCurKey / this.NCount)];
        idxMiddleKey = this.VBase + (idxCurKey % this.NCount) / this.TCount;
        idxLastKey = this.finale[idxCurKey % this.TCount];
        returnValue = String.fromCharCode(idxFirstKey, idxMiddleKey);
        if (idxLastKey != 0) {
          returnValue = returnValue + String.fromCharCode(idxLastKey);
        }
      }
      return returnValue;
    },
    splitWord: function(word, idxSplit) {
      var staticWord = word.substring(0, word.length - idxSplit);
      var tmpWord = word.substring(word.length - idxSplit, word.length);
      var returnArr = new Array(staticWord, tmpWord);
      return returnArr;
    },
  };
};

/*
if("p" == $mode1 && "i" == $mode2) {
		$bytes = hex2bin($result);
		$image = imagecreatefromstring($bytes);
		if ($image !== false) {
			header("Content-Type: image/png");
			imagepng($image);
			imagedestroy($image);
			return;
		} else {
			//echo 'An error occurred.';
		}
	} else {
		//response.setContentType("text/html");
		echo $result;
	}
 */
